module.exports = __webpack_public_path__ + "static/img/tip9.c309a1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/tip9.png
// module id = wM0z
// module chunks = 1